import {
    TRAINERS_POST_FAILURE,
    TRAINERS_POST_REQUEST,
    TRAINERS_POST_SUCCESS,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type, trainer} = action;
    switch (type) {
        case TRAINERS_POST_SUCCESS: {return {
            ...initialState,
            trainer,
        }}

        case TRAINERS_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case TRAINERS_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
